import React from 'react'
import Header from '../../components/Header/Header'
import ChooseServer from './ChooseServer'
import { DrawerMenu } from '../../components/Main/DrawerMenu'

const ChooseMain = () => {
  const [open, setOpen] = React.useState(false);
  const openDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);

  return (
    <div>
      <DrawerMenu isOpen={open} onCloseClick={closeDrawer} />
      <Header onDrawerClick={openDrawer} />
      <ChooseServer />
    </div>
  )
}

export default ChooseMain
